import React from 'react'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PaymentButtonInterface } from 'common/types/entities/PaymentButtonInterface'
import { buyMainOffer } from 'publisher/api/mollieApi'
import usePaymentSubmit from 'publisher/hooks/payment/usePaymentSubmit'
import { pageSelectors, usePage, usePayment } from 'publisher/store'
import paymentSelectors from 'publisher/store/payment/paymentSelectors'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { TwoStepPaymentFormStepInterface } from 'common/types/entities/two-step-payment-form-interface'

export default function useMolliePaymentHandler(
  entity:
    | OldEntityInterface
    | PaymentButtonInterface
    | BookingPaidCalendarInterface
    | TwoStepPaymentFormStepInterface,
) {
  const { errors, isLoading, submit } = usePaymentSubmit(entity)
  const purchaseProcessId = usePayment(paymentSelectors.getPurchaseProcessId)
  const pageId = usePage(pageSelectors.getPageId)

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault()
    submit(async body => {
      const { data } = await buyMainOffer(pageId, purchaseProcessId, {
        payment_form: body,
      })

      if (data.redirect) {
        window.location.assign(data.redirect)
        return
      }
    })
  }

  return { errors, isLoading, handleSubmit }
}
